import { render, staticRenderFns } from "./GuestVendConsultHandle.vue?vue&type=template&id=bbbd3ba2"
import script from "./GuestVendConsultHandle.vue?vue&type=script&lang=js"
export * from "./GuestVendConsultHandle.vue?vue&type=script&lang=js"
import style0 from "./GuestVendConsultHandle.vue?vue&type=style&index=0&id=bbbd3ba2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports